import {
  NewFormatConditionType,
  NewFormatConditionValue,
  OperatorId,
} from "./rules";

export enum TransactionItemFieldIds {
  CATEGORY = "category",
  LABELS = "labels",
  NAME = "name",
  GROSS_VALUE = "grossValue",
  SKU = "sku",
  MAKER = "maker",
}

export type TransactionItemFilterType = {
  value: {
    field: `${TransactionItemFieldIds}`;
  };
  condition: {
    operator: `${OperatorId}`;
    value: NewFormatConditionValue;
  };
  type: NewFormatConditionType;
  label: string;
  isSaved?: boolean;
  isEditMode?: boolean;
};

export type TransactionItem = {
  code: string;
  name: string;
  filters: TransactionItemFilterType[];
};
